import { Tab } from "../helper-classes/Tab";
import { SettingIcons } from "./icon-maps";
import { SettingTypes } from "../constants/enums";

export const UsersIndexTabs = [
  new Tab("All Users", "all", ""),
  new Tab("Admins", "admin", ""),
  new Tab("Designers", "designer", ""),
  new Tab("Crew", "crew", "")
];

export const SettingsTabs = [
  new Tab(
    "User Account",
    SettingTypes.USER,
    SettingIcons[SettingTypes.USER],
    null
  ),
  new Tab(
    "Scope Items",
    SettingTypes.SCOPE,
    SettingIcons[SettingTypes.SCOPE],
    null
  )
];
